export default "__VITE_ASSET__V5FgpiFL__$_?url__"